import React from 'react'
import { toast } from 'react-toastify'

const errorToast = (message, options = {}) => {
  const defaultOptions = {
    draggable: false,
    progress: undefined,
    style: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      maxWidth: '90vw'
    }
  }
  const mergedOptions = { ...defaultOptions, ...options }

  toast.error(message, mergedOptions)
}

export default errorToast
